module.exports = __webpack_public_path__ + "img/info-3.a995c784.svg";